import { useMemo } from "react";

import { useConfiguration } from "@is/hooks";
import { getConfigurationStyles } from "@is/utils";

const useManageErrorPage = () => {
  const { appearance } = useConfiguration();

  const styles = useMemo(
    () => getConfigurationStyles(appearance),
    [appearance]
  );

  return { styles };
};

export default useManageErrorPage;
